import { useState } from 'react';
import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/home';

export default function FeaturedGrid() {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section className="relative bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
            每日大赛
            <span className="inline-block ml-2 md:ml-3 text-3xl md:text-4xl">🎬</span>
            <br />
            热门爆料
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500">
            最新网红明星黑料一网打尽，吃瓜不停歇
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                idx === 0 ? 'lg:col-span-1 lg:row-span-2' : ''
              } ${idx === 1 ? 'lg:col-span-1' : ''}`}
              style={{ aspectRatio: idx === 0 ? '3/4' : '3/4' }}
              onMouseEnter={() => setHoveredId(article.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading={idx < 3 ? 'eager' : 'lazy'}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>

              {article.hot && (
                <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-fire-line"></i>
                  HOT
                </div>
              )}

              <div
                className={`absolute inset-x-0 bottom-0 p-4 md:p-5 transition-all duration-500 ${
                  hoveredId === article.id ? 'opacity-100 translate-y-0' : 'opacity-100'
                }`}
              >
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500/80 text-background-50 text-xs mb-3">
                  {article.category}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p
                  className={`text-sm text-background-50/70 line-clamp-2 leading-relaxed transition-all duration-500 ${
                    hoveredId === article.id ? 'opacity-100 max-h-20' : 'opacity-70 max-h-10 md:max-h-10'
                  }`}
                >
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-3 text-xs text-background-50/50">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views}
                  </span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/mingxing-tafang"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}